module.exports = __webpack_public_path__ + "img/diamante.ebbe2a0c.png";